const initialState = () => ({
    all: []
});

const siteTashDepositReducer = (state = initialState(), action) => {
    const newState = Object.assign({}, state);
    switch (action.type) {
        case 'SITE_TRASH_DEPOSIT_RECEIVED':
            newState.all = action.payload.sort((a, b) => {
                if (a.date > b.date ) return -1;
                if (a.date < b.date ) return 1;
                return 0;
            });
            return newState;
        case 'SITE_TRASH_DEPOSIT_CREATED':
            newState.all.push(action.payload);
            return newState;
        case 'SITE_TRASH_DEPOSIT_EDITED':
            newState.all.forEach((tash_deposit, idx) => {
                if (tash_deposit.id === action.payload.id) {
                    newState.all[idx] = {...action.payload };
                }
            });
            return newState;
        case 'SITE_TRASH_DEPOSIT_DELETED':
            newState.all.forEach((tash_deposit, idx) => {
                if (tash_deposit.id === action.payload) {
                    newState.all.splice(idx, 1);
                }
            });
            return newState;
        case 'SITE_TRASH_DEPOSIT_UPLOAD_PICTURES_SUCCESS':
            newState.all.forEach((trash_deposit, idx) => {
                if (parseInt(trash_deposit.id) === parseInt(action.payload[0].data.trash_deposit_id)) {
                    action.payload.forEach(row => {
                        newState.all[idx].pictures.push(row.data);
                    });
                }
            });
            return newState;
        case 'PICTURE_UPDATED':
            if (!action.payload.trash_deposit_id) return state;
            newState.all.forEach((m, idx) => {
                if (m.id === action.payload.trash_deposit_id) {
                    newState.all[idx].pictures.forEach((p, m_idx) => {
                        if (newState.all[idx].pictures[m_idx].id === action.payload.id) {
                            newState.all[idx].pictures[m_idx].comment = action.payload.comment;
                        }
                    });
                }
            });
            return newState;
        case 'PICTURE_REMOVE_SUCCESS':
            if (!action.payload.trash_deposit_id) return state;
            newState.all.forEach((m, idx) => {
                if (m.id === action.payload.trash_deposit_id) {
                    newState.all[idx].pictures.forEach((p, m_idx) => {
                        if (newState.all[idx].pictures[m_idx].id === action.payload.id) {
                            newState.all[idx].pictures.splice(m_idx, 1);
                        }
                    });
                }
            });
            return newState;
        case 'LOGOUT':
            return Object.assign({}, initialState());
        default:
            return state;
    }
};

export default siteTashDepositReducer;


